<template lang="pug">
div
  h4.mr-3 Configuración de API
  div Para utilizar nuestra API debes crear una API Key, que es una clave que te permite acceder a nuestros servicios.
  div Puedes encontrar más información sobre cómo utilizar nuestra API en la documentación que puedes descargar en el siguiente enlace:
  a(href="Envios_now_API_Docs.pdf" target="_blank" style="color: #007bff;") Documentación de la API
  div.mb-2.mt-4(style="display: flex; justify-content: space-between; align-items: center; max-width: 100%;")
    h5 Tus API Keys
    b-button(
      v-b-modal.api-key-form
      size="sm"
    ) Crear API Key
  b-table(:items="tableItems" :fields="fields")
    template(#cell(actions)="{ item }")
      div(style="display: flex; align-items: center; gap: 8px;")
        .material-icons-outlined.text-primary(
          @click="copyApiKey(item.key)"
          style="cursor: pointer;"
        ) copy
        .material-icons-outlined.text-danger(
          @click="handleDeleteApiKey(item.id)"
          style="cursor: pointer;"
        ) delete
    template(#cell(isActive)="{ item }")
      b-form-checkbox(
        v-model="item.isActive"
        variant="primary"
        switch
        @change="toggleActive(item)"
      )
  div(
    v-if="rowCount === 0 && !loadingApiKeys"
    class="text-center"
  ) No se encontraron API Keys
  b-pagination(
    v-else
    align="center"
    :per-page="rowsPerPage"
    :total-rows="rowCount"
    v-model="currentPage"
    @input="fetchApiKeys"
  )
  ApiKeyForm(
    @done="fetchApiKeys"
  )
</template>

<script>
import ApiKeyForm from './ApiKeyForm.vue'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    ApiKeyForm
  },
  data () {
    return {
      apiKeys: [],
      loadingApiKeys: false,
      fields: [
        { key: 'name', label: 'Nombre' },
        { key: 'key', label: 'Key' },
        { key: 'isActive', label: 'Activo' },
        { key: 'actions', label: 'Acciones' }
      ],
      rowsPerPage: 5,
      currentPage: 1,
      rowCount: 0
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.rowCount / this.rowsPerPage) || 1
    },
    tableItems () {
      return this.apiKeys.map(apiKey => ({
        ...apiKey,
        humanizeLastUsedAt: apiKey.lastUsedAt ? moment(apiKey.lastUsedAt).format('DD-MM-YYYY HH:mm') : 'Nunca'
      }))
    }
  },
  methods: {
    ...mapActions(['getApiKeys', 'updateApiKey', 'deleteApiKey']),
    copyApiKey (key) {
      navigator.clipboard.writeText(key)
      this.$bvToast.toast('Key copiada exitosamente', {
        title: 'Éxito',
        variant: 'success'
      })
    },
    async fetchApiKeys () {
      this.loadingApiKeys = true
      try {
        const params = {
          limit: this.rowsPerPage,
          offset: (this.currentPage - 1) * this.rowsPerPage
        }
        const response = await this.getApiKeys({ params })
        this.apiKeys = response.data.rows
        this.rowCount = response.data.count
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingApiKeys = false
      }
    },
    async toggleActive (item) {
      try {
        await this.updateApiKey({ id: item.id, data: { isActive: item.isActive } })
        this.$bvToast.toast('API Key actualizada exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
      } catch (error) {
        console.error(error)
      }
    },
    async handleDeleteApiKey (id) {
      const ok = await this.$bvModal.msgBoxConfirm('¿Estás seguro de eliminar esta API Key?', {
        title: 'Eliminar API Key',
        okVariant: 'danger',
        cancelVariant: 'secondary',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar'
      })
      if (!ok) return

      try {
        await this.deleteApiKey(id)
        this.$bvToast.toast('API Key eliminada exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
        this.fetchApiKeys()
      } catch (error) {
        console.error(error)
      }
    }
  },
  mounted () {
    this.fetchApiKeys()
  }
}
</script>
